/**
 * Created by stonewang on 2017/8/29.
 */
import {config, request} from 'Utils';

//仓库列表
export function list(param) {
  return request(`${config.server}/api/v1/dms/storage/list`, {
    method: 'post',
    body: param,
  });
}
//品牌商仓库 新增入库单
export function listForBill(param) {
  return request(`${config.server}/api/v1/dms/storage/listForBill`, {
    method: 'post',
    body: param,
  });
}
//新增仓库
export function add(param) {
  /*{
   acreage (string, optional): 仓库面积 ,
   active (integer, optional): 是否有效 ,
   address (string, optional): 详细地址 ,
   areaIdList (Array[integer], optional): 辐射区域ID集合 ,
   city (string, optional): 城市 ,
   code (string, optional): 仓库编号 ,
   contacts (string, optional): 联系人 ,
   contactsMobile (string, optional): 联系人手机 ,
   county (string, optional): 区县 ,
   id (integer, optional): 主键ID ,
   localFlag (integer, optional): 是否启用货位 ,
   name (string, optional): 仓库名称 ,
   orgId (integer, optional): 所属组织 ,
   province (string, optional): 省份 ,
   areaIdList (Array[DmsStorageArea], optional): 辐射区域 ,
   storageLocalList (Array[DmsStorageLocal], optional): 货位列表 ,
   storageType (integer, optional): 仓库类型
  }
  * */
  return request(`${config.server}/api/v1/dms/storage/save`, {
    method: 'post',
    body: param,
  });
}
//编辑仓库
export function update(param) {
  return request(`${config.server}/api/v1/dms/storage/update`, {
    method: 'post',
    body: param,
  });
}
//仓库详情
export function detail(id) {
  return request(`${config.server}/api/v1/dms/storage/detail?id=${id}`, {
    method: 'post',
    //body: param,
  });
}
//货位列表
export function getLocalList(param) {
  return request(`${config.server}/api/v1/dms/storage/getLocalList`, {
    method: 'post',
    body: param,
  });
}
//新增仓库货位
export function saveLocal(param) {
  /*
   {
   code (string, optional): 货位编号 ,
   desc (string, optional): 货位描述 ,
   storageId (integer, optional): 仓库ID
   }
  * */
  return request(`${config.server}/api/v1/dms/storage/saveLocal`, {
    method: 'post',
    body: param,
  });
}
//修改仓库货位
export function updateLocal(param) {
  return request(`${config.server}/api/v1/dms/storage/updateLocal`, {
    method: 'post',
    body: param,
  });
}
//删除仓库货位 POST
export function deleteLocal(param) {
  return request(`${config.server}/api/v1/dms/storage/deleteLocal?id=${param.id}`);
}


// WEBPACK FOOTER //
// ./src/service/inventory/house.js